import { useEffect } from "react";
import Hero from "@/components/site/Hero";
import EditorialMarquee from "@/components/site/Marquee";
import Pillars from "@/components/site/Pillars";
import Offerings from "@/components/site/Offerings";
import Manifesto from "@/components/site/Manifesto";
import ContactForm from "@/components/site/ContactForm";
import { CONTACT } from "@/constants/testIds";
import { motion } from "framer-motion";
import { Instagram } from "lucide-react";
import { SITE } from "@/constants/site";

const Home = () => {
  useEffect(() => {
    document.title = "TWGAS Athletics · The Work Gone Always Show";
  }, []);

  return (
    <main>
      <Hero />
      <EditorialMarquee />
      <Pillars />
      <Offerings />
      <Manifesto />

      {/* Contact block on home */}
      <section
        id="contact"
        data-testid={CONTACT.root}
        className="section-rule bg-black py-24 md:py-32"
      >
        <div className="mx-auto max-w-[1440px] px-5 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
          <div className="md:col-span-5">
            <div className="num-tag mb-4">/ CHAPTER 05 · CONTACT</div>
            <motion.h2
              initial={{ y: 40, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
              className="font-display uppercase text-5xl md:text-7xl leading-[0.9] tracking-tight"
            >
              Ready when
              <br />
              <span className="stroke-fire">you are.</span>
            </motion.h2>
            <p className="mt-6 text-zinc-400 max-w-[42ch] text-base md:text-lg leading-relaxed">
              Drop your details and we'll get on a call. Or slide into the DMs
              directly — same team either way.
            </p>
            <a
              href={SITE.instagramUrl}
              target="_blank"
              rel="noreferrer"
              data-testid={CONTACT.instagramCta}
              className="mt-8 inline-flex items-center gap-3 border border-white/10 px-5 py-4 hover:border-[#FF4D00] hover:text-[#FF4D00] transition-colors"
            >
              <Instagram size={16} />
              <span className="font-display uppercase text-lg tracking-wide">
                DM {SITE.instagramHandle}
              </span>
            </a>
          </div>

          <div className="md:col-span-7">
            <ContactForm />
          </div>
        </div>
      </section>
    </main>
  );
};

export default Home;
